import * as React from "react";

import { GatsbyImage } from "gatsby-plugin-image";

// markup
const Benefits = ({ data }) => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div className="flex items-center">
        <GatsbyImage
          image={data.familyTime.childImageSharp.gatsbyImageData}
          alt="Bond as a family"
          className="object-cover w-1/2 rounded-lg shadow-lg" />
        <div className="w-1/2 px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
          <div className="md:ml-auto md:pl-10">
            <p className="mt-2 text-gray-700 text-3xl font-extrabold tracking-tight sm:text-4xl">
              Save Time
            </p>
            <p className="mt-3 text-lg text-gray-700">
              The average household spends nearly 20 hours a month doing
              laundry. Choose <b>life over laundry</b> and let our home laundry
              service lighten your load with convenient wash and fold plans
              built for busy families.​
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-1/2 px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
          <div className="md:ml-auto md:pl-10">
            <p className="mt-2 text-gray-700 text-3xl font-extrabold tracking-tight sm:text-4xl">
              Safe for your Family
            </p>
            <p className="mt-3 text-lg text-gray-900">
              We make it easy to go green by using eco-friendly solutions free
              of all the harsh ingredients. No sulphates, phosphates, optical
              brighteners, or scents – <b>just clean clothes</b>.
            </p>
          </div>
        </div>
        <GatsbyImage
          image={data.environment.childImageSharp.gatsbyImageData}
          alt="Good for the environment"
          className="object-cover w-1/2 rounded-lg shadow-lg" />
      </div>
    </div>
  );
};

export default Benefits;
